export default "__VITE_ASSET__BWBu1HqW__"